module.exports = __webpack_public_path__ + "static/media/code.00679319.png";